import * as React from 'react';
import { SelectValue } from '../../../../../Components/Base/Select/Select';
import { FieldError } from 'react-hook-form';
import TermItemSelect from '../TermItemSelect/TermItemSelect';

interface Props {
	onChange?: (value: SelectValue) => void;
	value?: SelectValue;
	error?: FieldError;
}

const VATRateSelect: React.FC<Props> = props => (
	<TermItemSelect {...props} termType='vat_rate' useKey='value' />
);

export default VATRateSelect;
